<template>
  <el-pagination style="width: 100%;padding: 5px 0;margin: 30px 0 0 0;text-align: center;"
                 :current-page.sync="currentPageIndex"
                 :page-size="currentPageSize"
                 :page-sizes="pageSizes"
                 layout="sizes, prev, pager, next, jumper"
                 :total="total"
                 @size-change="onPageSizeChange"
                 @current-change="onPageChange" />
</template>

<script>

export default {
  name: "UIPageBar",
  props: {
    pageSize: { type: Number, default: 10 },
    pageSizes: { type: Array, default: () => { return [10, 20, 50, 100, 200, 500, 1000] } },
    pageIndex: { type: Number, default: 1 },
    currentPageCount: { type: Number, default: 0 },
  },
  data() {
    return {
      currentPageSize: this.pageSize,
      currentPageIndex: this.pageIndex
    };
  },
  computed: {
    total() {
      if (this.currentPageCount >= this.currentPageSize) {
        return this.currentPageSize * 999999
      } else {
        return this.currentPageIndex * this.currentPageSize
      }
    }
  },
  methods: {
    onPageChange() {
      this.$emit('update:pageIndex', this.currentPageIndex)
      this.$emit('page-changed', [this.currentPageSize * (this.currentPageIndex - 1), this.currentPageSize * this.currentPageIndex])
    },
    onPageSizeChange(sz) {
      this.currentPageSize = sz
      this.$emit('update:pageSize', sz)
      this.onPageChange()
    },
  }
};
</script>
